var map = {
	"./31/WhitelistSFTClaims.json": 25647,
	"./32/WhitelistSFTClaims.json": 81876,
	"./33/WhitelistSFTClaims.json": 28805,
	"./34/WhitelistSFTClaims.json": 46778,
	"./35/WhitelistSFTClaims.json": 78539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58090;